import React from 'react';
import { ProfileMessageInput, useProfileMessagingState } from '../../../shared/ProfileMessaging';
import { SideDrawerButtonContainer } from '../../Form/SideDrawerFormContainer';
import { getIntl } from '../../../../utils/intl';
import MainContentContainer from '../../MainContentContainer';

const intl = getIntl(
    'components.screens.tabs.profiles.profileActivityScreen.desktopRecentActivitySection.sendMessageContent',
    {
        sendMessage: 'Send Message',
    },
);

export type SendMessageContentOwnProps = {
    onClose: (force: boolean) => void;
    profileId: string;
};

export type SendMessageContentProps = SendMessageContentOwnProps;

const SendMessageContent: React.FC<SendMessageContentProps> = (props) => {
    const { onSend, isSendDisabled, message, setMessage } = useProfileMessagingState({
        onCancel: () => props.onClose(true),
        onClose: () => props.onClose(true),
        selectedProfileIds: [props.profileId],
    });

    return (
        <SideDrawerButtonContainer
            disableScroll
            disablePadding
            buttons={[
                {
                    title: intl('sendMessage'),
                    icon: 'Send',
                    onPress: onSend,
                    isDisabled: isSendDisabled,
                    testID: 'submit-add-message',
                    variant: 'primary',
                },
            ]}
        >
            <MainContentContainer style={{ width: '100%', height: '100%' }}>
                <ProfileMessageInput
                    selectedProfileIds={[props.profileId]}
                    message={message}
                    setMessage={setMessage}
                    type="profile"
                    isDisabled={isSendDisabled}
                />
            </MainContentContainer>
        </SideDrawerButtonContainer>
    );
};

export default React.memo(SendMessageContent);
